import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
// thunkAPI.dispatch(successSnack('Fetched Users'));
// thunkAPI.dispatch(infoSnack('Look at these Users'));
// thunkAPI.dispatch(errorSnack('User error'));
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

const getParent = (category, list) => {
  if (category.parentID === null) {
    return;
  } else {
    let parent = list.filter((cats) => cats.id === category.parentID);
    return parent[0];
  }
};

const getParents = (category, list) => {
  console.log("firing get parents");
  let parentsArr = [];
  let hasParent = true;
  let currentCat = JSON.parse(JSON.stringify(category));
  while (hasParent) {
    let parent = getParent(currentCat, list);
    if (parent) {
      parentsArr.push(parent.name);
      currentCat = parent;
    } else {
      hasParent = false;
    }
  }

  return parentsArr.length ? parentsArr.reverse().join(" > ") : "";
};

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/categories${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setCategoriesAmount(response.headers["x-total-count"]));

      return (await response.data) === null ? [] : response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching categories"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreCategories = createAsyncThunk(
  "categories/fetchMoreCategories",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/categories${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setCategoriesAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterCategories = createAsyncThunk(
  "categories/filterCategories",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/categories${args.query}`,
        config
      );
      response.data.length &&
        response.data.forEach((category) => {
          let parents = getParents(category, response.data);
          category.parentList = parents;
        });

      return (await response.data) === null ? [] : response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchCategoriesTree = createAsyncThunk(
  "categories/fetchCategoriesTree",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/categories/tree`,
        config
      );

      let updatedCatTree = JSON.parse(JSON.stringify(response.data));
      for (let i = 0; i < updatedCatTree.length; i++) {
        const parentCategory = updatedCatTree[i];
        if (
          parentCategory.subCategories &&
          parentCategory.subCategories.length
        ) {
          for (let j = parentCategory.subCategories.length - 1; j >= 0; j--) {
            const cat = parentCategory.subCategories[j];

            if (cat.depth > 2) {
              let catParent = parentCategory.subCategories.find(
                (o) => o.id === cat.parentID
              );
              if (catParent) {
                if (!catParent.subCategories) {
                  catParent.subCategories = [];
                }
                catParent.subCategories.push(cat);
              }
            }
          }
        }
      }

      return updatedCatTree;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching categories tree list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchCategoryByID = createAsyncThunk(
  "categories/fetchCategoryByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.get(
        `${baseURL}/v1/admin/categories/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching category data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.delete(
        `${baseURL}/v1/admin/categories/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Category deleted successfully"));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting category"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/categories/${args.id}`,
        args.category,
        config
      );

      thunkAPI.dispatch(fetchCategories({ token: args.token, query: "?limit=100" }));

      thunkAPI.dispatch(fetchCategoriesTree({ token: args.token }));
      thunkAPI.dispatch(successSnack("Category updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating category"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createCategory = createAsyncThunk(
  "categories/createCategory",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.post(
        `${baseURL}/v1/admin/categories`,
        args.category,
        config
      );
      thunkAPI.dispatch(fetchCategories({ token: args.token, query: "" }));
      thunkAPI.dispatch(fetchCategoriesTree({ token: args.token }));

      thunkAPI.dispatch(successSnack("Category created successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating category"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreCategories(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    category: {},
    categoriesFilter: [],
    categoriesList: [],
    categoriesTree: [],
    loading: "idle",
    message: "",
    editing: false,
    error: "",
    categoriesAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setCategoriesAmount: (state, action) => {
      state.categoriesAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategories.pending, (state) => {
      state.categoriesList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchCategories.fulfilled, (state, { payload }) => {
      state.categoriesList = payload;
      state.categoriesFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchCategories.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreCategories.fulfilled, (state, { payload }) => {
      state.error = "";
      state.categoriesList = state.categoriesList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreCategories.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.categoriesList = state.categoriesList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterCategories.pending, (state) => {
      state.categoriesFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterCategories.fulfilled, (state, { payload }) => {
      state.categoriesFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterCategories.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchCategoriesTree.pending, (state) => {
      state.categoriesTree = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchCategoriesTree.fulfilled, (state, { payload }) => {
      state.categoriesTree = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchCategoriesTree.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchCategoryByID.pending, (state) => {
      state.category = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchCategoryByID.fulfilled, (state, { payload }) => {
      state.category = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchCategoryByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteCategory.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(deleteCategory.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateCategory.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateCategory.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createCategory.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createCategory.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createCategory.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setCategoriesAmount } = categoriesSlice.actions;

export const selectCategories = createSelector(
  (state) => ({
    categories: state.categories,
    loading: state.categories.loading,
    error: state.categories.error,
    editing: state.categories.editing,
    category: state.categories.category,
    categoriesList: state.categories.categoriesList,
    categoriesFilter: state.categories.categoriesFilter,
    categoriesTree: state.categories.categoriesTree,
    categoriesAmount: state.categories.categoriesAmount,
    lastQuery: state.categories.lastQuery,
  }),
  (state) => state
);
export default categoriesSlice.reducer;
